import { fetchWithAuth } from '../../auth/auth';
import { getApiUrl } from '../../utils/getApiUrl';

export const createDictionary = async (
  userId: number, 
  name: string,
  idlanguage: number,
  showSpinner: () => void, 
  hideSpinner: () => void,
 ): Promise<void> => {
  if (!name.trim()) {
    throw new Error("Please enter a name.");
  }

  showSpinner();
  const res = await fetchWithAuth(getApiUrl("dictionaries/add"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ iduser: userId, name: name.trim(), idlanguage }),
  });

  hideSpinner();
  if (!res.ok) {
    throw new Error("Failed to create dictionary");
  }
};

export const updateDictionary = async (
  id: number, 
  name: string,  
  showSpinner: () => void, 
  hideSpinner: () => void
  ): Promise<void> => {
  if (!name.trim()) {
    throw new Error("Please enter a name.");
  }

  showSpinner();
  const res = await fetchWithAuth(getApiUrl(`dictionaries/update/${id}`), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: name.trim() }),
  });

  hideSpinner();
  if (!res.ok) {
    throw new Error("Failed to update dictionary");
  }
};

export const deleteDictionary = async (
  id: number,
  showSpinner: () => void, 
  hideSpinner: () => void
  ): Promise<void> => {

  showSpinner();
  const res = await fetchWithAuth(getApiUrl(`dictionaries/delete/${id}`), {
    method: "DELETE",
  });

  hideSpinner();
  if (!res.ok) {
    throw new Error("Failed to delete dictionary");
  }
};